import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  useCaseList: [],
};

export const featuredUseCasesSlice = createSlice({
  name: "featuredUseCases",
  initialState,
  reducers: {
    featuredUseCasesStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    featuredUseCasesSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      useCaseList: action.payload,
    }),
    featuredUseCasesFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetFeaturedUseCases: () => ({
      ...initialState,
    })
  },
});

export const { 
  featuredUseCasesStart,
  featuredUseCasesSuccess,
  featuredUseCasesFailure,
  resetFeaturedUseCases,
} = featuredUseCasesSlice.actions;

export const getFeaturedUseCases = () => (dispatch) => {
  dispatch(featuredUseCasesStart());
  const apiPath = Constants.API.HOME_PAGE + Constants.API.FEATURED_USE_CASE;
  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(featuredUseCasesSuccess(data?.data));
      } else {
        dispatch(featuredUseCasesFailure());
      }
    } else {
      dispatch(featuredUseCasesFailure());
    }
  }).catch(() => {
    dispatch(featuredUseCasesFailure());
  })
};

export default featuredUseCasesSlice.reducer;
